import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

export default function LoaderFeedback() {
  const { loading, message, status } = useSelector((state) => state.feedback);
  return (
    <div className={`loader-feedback ${loading ? "loader-feedback-visible" : ""}`}>
      <div className="bg-dark" />
      <div className="feedback-content">
        {status === "" && <CircularProgress className="feedback-spinner" />}
        {status === "s" && (
          <div className="feedback-success">
            <CheckIcon />
          </div>
        )}
        {status === "f" && (
          <div className="feedback-fail">
            <CloseIcon />
          </div>
        )}
        {status === "i" && (
          <div className="feedback-fail">
            <CloseIcon />
          </div>
        )}
        <p>{message}</p>
      </div>
    </div>
  );
}
